
import { useCallback } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { NavBar, PageHeader } from '@/components/ui';
import { PullToRefresh } from '@/components/common/PullToRefresh';

export function StorePage() {
  // Placeholder page — no data yet; brief delay so the spinner is visible.
  const handleRefresh = useCallback(
    () => new Promise<void>((resolve) => setTimeout(resolve, 400)),
    [],
  );

  return (
    <Box
      minH="100vh"
      bg="white"
      pb={{ base: 'var(--mobile-bottom-safe)', lg: '6' }}
      pl={{ lg: 'var(--sidebar-width)' }}
      transition="all 0.3s"
    >
      <PullToRefresh onRefresh={handleRefresh}>
      <Box maxW="800px" mx="auto" p="5">
        <PageHeader
          title="Store"
          profileDropdownProps={{
            showRewards: false,
            onRewardsClick: () => {},
          }}
        />

        <Box mt={10} textAlign="center">
          <Text fontSize="lg" fontWeight="semibold" color="volyx.primary" mb={2}>
            Coming soon
          </Text>
          <Text fontSize="sm" color="volyx.textSecondary">
            The Volyx store is not available yet. Stay tuned for upcoming rewards.
          </Text>
        </Box>
      </Box>
      </PullToRefresh>
      <NavBar />
    </Box>
  );
}
